import React from "react";
import { InputMascara } from "./InputMascara";


export type InputCnpjProps = {
    cnpj:string,
    onCnpjModificado: (cpf:string) => void
    emitirComMascara?: boolean
}

export const InputCnpj = (props: InputCnpjProps) => <InputMascara 
    mascara="99.999.999/9999-99"
    emitirComMascara={props.emitirComMascara === undefined || props.emitirComMascara === true}
    onValorModificado={props.onCnpjModificado}
    inputMode="numeric"
    type="tel"
    valor={props.cnpj}/>